import type { ISbError } from '@storyblok/js'

export const isStoryblokError = (error: unknown): error is ISbError => {
  return typeof error === 'object' && error !== null && 'message' in error && 'status' in error
}

/**
 * Returns true if the current page is opened in storyblok.
 * 
 * Only works client side.
 */
export const isOpenInStoryblok = (): boolean => {
  // https://github.com/storyblok/monoblok/blob/6a71d01c8802b3ea52e5b72451654f036a01519b/packages/js/src/index.ts#L37
  if (import.meta.server) {
    return false
  }
  const storyId = new URL(window.location?.href).searchParams.get(
    '_storyblok',
  )
  return !!window.storyblokRegisterEvent && !!storyId
}
